<script>
import { Pie } from "vue-chartjs";

export default {
  name: "IdCardPieChart",
  extends: Pie,
  props: {
    counts: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.$el.style.height = "100px";
    this.$el.style.width = "100px";
  },
  watch: {
    counts: {
      deep: true,
      immediate: true,
      handler(newCounts) {
        this.renderChart(
          {
            labels: ["Offen", "Genehmigt", "Aktiv", "Abgelaufen"],
            datasets: [
              {
                data: [
                  newCounts.open || 0,
                  newCounts.approved || 0,
                  newCounts.active || 0,
                  newCounts.expired || 0,
                ],
                backgroundColor: [
                  "#005b9b",
                  "rgb(238,174,91)",
                  "rgb(25, 135, 84)",
                  "grey",
                ],
              },
            ],
          },
          {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
          }
        );
      },
    },
  },
};
</script>
